<!--
 * @Author: WGL
 * @Date: 2023-06-21 09:23:33
 * @LastEditors: WGL 958897276@qq.com
 * @LastEditTime: 2025-08-18 15:07:50
 * @Description: 
-->
<template>
  {{ stockText }}
  <el-popover
    v-if="thirdStockList"
    :persistent="false"
    placement="right"
    trigger="hover"
    :width="400"
  >
    <template #reference>
      <view v-if="thirdStockList" class="cd cp w omit">
        {{ thirdStockText }}
      </view>
    </template>
    <el-table :data="thirdStockList">
      <el-table-column
        :label="t('三方仓库名')"
        min-width="150"
        property="third_repository_info.title"
      />
      <el-table-column :label="t('数量')" property="num" width="100" />
    </el-table>
  </el-popover>
</template>

<script>
  // 基础产品库存数量组件
  import { computed, defineComponent } from 'vue'
  import { t } from '@/utils/i18n'

  export default defineComponent({
    name: 'BaseStock',
    components: {},
    props: {
      info: { type: Object, default: () => {} },
      showThirdStock: { type: Boolean, default: false },
    },
    setup(props) {
      const stockText = computed(() => {
        const productInfo = props?.info?.product_info || props?.info
        const stockNum = +productInfo?.stock || 0
        const freezeNum = productInfo?.dynamic_info?.freeze_num || 0
        const unitTetx = productInfo?.unit || '-'
        return `${stockNum}-${freezeNum}=${stockNum - freezeNum} (${unitTetx})`
      })
      const thirdStockList = computed(() => {
        if (!props.showThirdStock) {
          return false
        }
        if (props?.info?.third_repository_list?.length) {
          return props?.info?.third_repository_list || []
        }
        return false
      })
      const thirdStockText = computed(() => {
        if (thirdStockList.value) {
          let text = `${
            thirdStockList.value[0]?.third_repository_info?.title || ''
          }(${thirdStockList.value[0]?.num || 0})`
          if (thirdStockList.value.length > 1) {
            text += '...'
          }
          return text
        }
        return ''
      })
      return {
        stockText,
        thirdStockText,
        thirdStockList,
        t,
      }
    },
  })
</script>

<style lang="scss" scoped></style>
